import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, Spinner } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";
import ConfirmationModal from "../../Controls/ConfirmationModal";
import CommonFunctions from "../../../utils/helpers/CommonFunctions";
import RBSProcess from "../../Dispatch/RBSProcess";

const Route = (props) => {
    const { AffiliateData, GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showRouteAlert, setRouteAlert] = useState(false);
    const [routeAlertObj, setRouteAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes'
    });
    const [confirmationModalObjForDay, setConfirmationModalObjForDay] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes'
    });
    const [confirmationModalSimpleObj, setConfirmationModalSimpleObj] = useState({
        show: false, title: 'Route Assignment Restricted',
        body: 'Routed/No-Show/Cancelled Trip(s) will not participate in this routing action.', btnCanceText: 'No',
        btnOkText: 'OK'
    });
    const clusterComboData = useRef([]);
    useEffect(() => {
        async function fetchData() {
            if (props.GridRowData === null || props.GridRowData.length <= 0) {
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Action', alertMsg: 'No request selected to perform Action.', displayFooter: true });
                setRouteAlert(true);
            }
            else {

                //let result = await CommonFunctions.checkAutoRouting(props.selectedAffiliates, props.selectedDate, AffiliateData);
                let result = false;
                if (result) {
                    setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Auto Routing', body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No', btnOkText: 'Yes' }));
                } else {
                    await RoutingActions();
                }
            }
        }

        fetchData();

    }, []);

    const RoutingActions = async () => {
        const selectedGridData = props.GridRowData
        const pickupDateTime = selectedGridData[0].PickupDateTime;
        const affID = selectedGridData[0].iSRATSPID;
        let callBackURL = "";
        let bMessageShown = false;
        let bUnGroupedTripsFound = false;
        let cancelledOrRoutedOrNoshowTripsFound=false;
        const SelectedRecordsForARB = [];
        const normalizedSelectedData = [];
        const vServiceIDs = [...new Set(selectedGridData
            .map(data => data.ServiceID)
            .filter(ServiceID => ServiceID)
        )];
        const vScheduleIDs = [...new Set(selectedGridData
            .map(data => data.iScheduleID)
            .filter(iScheduleID => iScheduleID)
        )];


        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        for (let k = 0; k < selectedGridData.length; k++) {
            /* Commented becasue we were allowing change of assignments from Old Dispatch Screen
            if (selectedGridData[k].Route != "") {
                 setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'Please select only unrouted trips!' , displayFooter: true});
                 setRouteAlert(true);
                 bMessageShown = true;
                 setConfirmationModalObj((prevState) => ({...prevState, show:false}));
                 break;
             }
             else */
            // if (props.setIsCreateNew
            //     && ((selectedGridData[k].Route != "" && selectedGridData[k].ClusterType.length == 0)
            //         || (selectedGridData[k].Route != "" && selectedGridData[k].ClusterType.length > 2 && selectedGridData[k].ClusterType[2] == 'R'))) {
            //     setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'Please select only unrouted trips!', displayFooter: true });
            //     setRouteAlert(true);
            //     bMessageShown = true;
            //     setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
            //     break;
            // }
            if (props.setIsCreateNew == false && selectedGridData[k].PickupPerson == "BreakTrip") {
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'Action not allowed for Break Trip!', displayFooter: true });
                setRouteAlert(true);
                bMessageShown = true;
                break;
            }
            else if (props.setIsCreateNew == false && (selectedGridData[k].PickupPerson == "SDepot" || selectedGridData[k].PickupPerson == "EDepot")) {
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'Action not allowed for Depot Trip!', displayFooter: true });
                setRouteAlert(true);
                bMessageShown = true;
                break;
            }
            else if (selectedGridData[k].iSRATSPID !== affID) {
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'Cannot Route trips with different affiliates!', displayFooter: true });
                setRouteAlert(true);
                bMessageShown = true;
                break;
            }
            else if (selectedGridData[k].CreatedBy === "(ExternalDispatch)") {
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'This is a broker trip, Route assignement is not allowed!', displayFooter: true });
                setRouteAlert(true);
                bMessageShown = true;
                break;
            }
            // else if (selectedGridData[k].TripRequestStatus.toLowerCase().indexOf("show") > -1
            //     || selectedGridData[k].ServiceStatus.toLowerCase().indexOf("show") > -1) {
            //     setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'NoShow trips can not be Route.', displayFooter: true });
            //     setRouteAlert(true);
            //     bMessageShown = true;
            //     break;
            // }
            else if (selectedGridData[k].TripRequestStatus.toLowerCase().indexOf("cancel") > -1
                || selectedGridData[k].ServiceStatus.toLowerCase().indexOf("cancel") > -1
           || selectedGridData[k].TripRequestStatus.toLowerCase().indexOf("show") > -1
                || selectedGridData[k].ServiceStatus.toLowerCase().indexOf("show") > -1
              ||  (selectedGridData[k].Route != "" && selectedGridData[k].ClusterType.length == 0 && props.setIsCreateNew == true)
                    || (selectedGridData[k].Route != "" && selectedGridData[k].ClusterType.length > 2 && selectedGridData[k].ClusterType[2] == 'R' && props.setIsCreateNew == true)
            ) {
                    cancelledOrRoutedOrNoshowTripsFound=true;
                //setConfirmationModalSimpleObj((prevState) => ({ ...prevState, show: true}));
            }
            // else if (selectedGridData.length === 1 && selectedGridData[k].PickupTime === "Will Call") {
            //     setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'This is a Will Call trip, Route assignement is not allowed!' , displayFooter: true});
            //     setRouteAlert(true);
            //     bMessageShown = true;
            //     break;
            // }
            /*
            else if (selectedGridData[k].iMVOriginalATSPID != "-1" && selectedGridData[k].iMVRouteATSPID != "-1") {
                if (selectedGridData[k].iMVOriginalATSPID != selectedGridData[k].iMVRouteATSPID) {
                    setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'This is a transfered route, group assignement is not allowed!' , displayFooter: true});
                    setRouteAlert(true);
                    bMessageShown = true;
                    return;
                }
            }
            */
            else {
                if (selectedGridData[k].Route === "")
                    bUnGroupedTripsFound = true;
                SelectedRecordsForARB.push({
                    AffiliateID: selectedGridData[k].iSRATSPID,
                    ServiceID: selectedGridData[k].ServiceID,
                    ScheduleID: String(selectedGridData[k].bIsSchedule).toUpperCase() === "TRUE" ? selectedGridData[k].iScheduleID : "-1",
                    Confirmation: selectedGridData[k].ConfirmationNo,
                    PickupDateTime: selectedGridData[k].PickupDateTime,
                    ManifestNumber: selectedGridData[k].vManifestNumber,
                    SchDetailID: selectedGridData[k].SchDetailID,
                    Group: selectedGridData[k].Group,
                });

                normalizedSelectedData.push({
                    ServiceID: selectedGridData[k].ServiceID,
                    ScheduleID: selectedGridData[k].iScheduleID,
                    iRefId: selectedGridData[k].ConfirmationNo
                });
            }
        }

        let myData = {
            vServiceIDs: vServiceIDs.join(','),
            vScheduleIDs: vScheduleIDs.join(','),
            normalizedSelectedData: normalizedSelectedData,
            pickupDateTime: pickupDateTime,
            affID: affID,
            manifestNumber: props.manifestNumber,
            callBackURL: callBackURL,
            SelectedRecordsForARB: SelectedRecordsForARB,
            SelectedRouteSettingID: props.SelectedRouteSettingID
        };
        props.disbaleButton(true);
        if (/*bUnGroupedTripsFound &&*/ props.showRouteActionCreate && SelectedRecordsForARB.length > 0 && !bMessageShown) {
            if (props.setIsCreateNew) {
                if(cancelledOrRoutedOrNoshowTripsFound){
                    setConfirmationModalSimpleObj((prevState) => ({ ...prevState, show: true}));
                }
                BuildManifestDispatchRequest(selectedGridData, affID, SelectedRecordsForARB, myData);
            }
            else {
                if(cancelledOrRoutedOrNoshowTripsFound){
                    setConfirmationModalSimpleObj((prevState) => ({ ...prevState, show: true}));
                }
                var myDataJSON = JSON.stringify(myData);
                sessionStorage.setItem('RecordIDs', myDataJSON); // for forcefully route
                let with_ersa = "1";
                if (props.force_assign) with_ersa = "0";
                checkSelectedForTheDay(vServiceIDs.join(','), vScheduleIDs.join(','), pickupDateTime, affID, with_ersa, props.manifestNumber, false, callBackURL, SelectedRecordsForARB, myData)
            }
        }
        /*
        else if (!bUnGroupedTripsFound && !bMessageShown) {
            setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Route Assignment Restricted', alertMsg: 'Please select atleast one un-grouped trip for this action!' , displayFooter: true});
            setRouteAlert(true);
        }
        */

    }

    async function checkSelectedForTheDay(serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj, myData) {
        if (manifest) {
            let route = manifest.substring(8);
            let body = {
                "vRouteNo": route,
                "vReqDate": reqDate,
                "vSettingID": String(props.SelectedRouteSettingID),
                "vAffiliateID": String(affID)
            }
            let result = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/checkRouteAddTodate", "post", { "Content-Type": "application/json" }, body, null);
            let data = result.data;
            let totalUnChecked = data.filter(function (a) { return a.Day == false; });
            let totalChecked = data.filter(function (a) { return a.Day == true; });
            let selectedRoute = data.find(function (a) { return a.Route == route; });

            if (data.length != totalUnChecked.length && data.length != totalChecked.length) {
                if (selectedRoute.Day == false) {
                    setConfirmationModalObjForDay((prevState) => ({ ...prevState, show: true, title: 'Selected Route Alert', body: 'Do you want to add this route to current date selection list?', btnCanceText: 'No', btnOkText: 'Yes' }));
                }
                else {
                    NewRoute(serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj, myData);
                }
            }
            else {
                NewRoute(serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj, myData);
            }
        }
        else {
            NewRoute(serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj, myData);
        }

    }
    const BuildManifestDispatchRequest = async (selectedGridData, iAffiliateID, SelectedRecordsForARB, myData) => {
        let ids = null;
        let callBackURL = "";
        let RecordIDs = "";
        ids = GetServiceNScheduleIDsForWillMRM_New(selectedGridData, true);
        const pickupDateTime = selectedGridData[0].PickupDateTime;
        // for (let k = 0; k < selectedGridData.length; k++) {
        //     let _dialogueMsgShown = false;
        //     if (selectedGridData[k].Route == "Will Call") {
        //         setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Assignment Restricted', alertMsg: 'Route Assignment for Will Call requests are not allowed.' , displayFooter: true});
        //         setRouteAlert(true);
        //         _dialogueMsgShown = true;
        //         break;
        //     }

        // }
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        let Data = {
            "Trips": JSON.stringify(SelectedRecordsForARB),
            "iAffiliateID": iAffiliateID,
            "dtPickupDateTime": pickupDateTime,
            "iCreatedByAppId": 26,
            "iCreatedByUID": loginData.iUserID,
            "call_back_url": callBackURL,
            "UpdateReason": 'Auto-Assign'
        }
        // RecordIDs += "Trips=" + JSON.stringify(ids[2]);
        // RecordIDs += "&iAffiliateID=" + iAffiliateID;
        // RecordIDs += "&dtPickupDateTime=" + pickupDateTime;
        // RecordIDs += "&iCreatedByAppId=" + 26;
        // RecordIDs += "&iCreatedByUID=" + loginData.iUserID;
        // RecordIDs += "&call_back_url=" + callBackURL;
        setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Initializing Routing Process', alertMsg: 'Please Wait...', displayFooter: false });
        setRouteAlert(true);
        props.disbaleButton(true);

        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/BuildManifestDispatch", "post", { "Content-Type": "application/json" }, Data, null);
        let result = response.data;
        if (result.run_id > 0) {
            updateSelectedRecords(result.DTSelectedRecordsForARB, myData);
            setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Started', alertMsg: 'Routing is being performed...', displayFooter: false });
            setRouteAlert(true);
            props.disbaleButton(false);
        }
        else {
            if (result.Error) {
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Auto Assignment', alertMsg: 'Error occurred !!!', displayFooter: true });
                setRouteAlert(true);
                props.disbaleButton(false);
                setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
            }
            else if (result.error_message) {
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Auto Assignment', alertMsg: result.error_message , displayFooter: true});
                setRouteAlert(true);
                props.disbaleButton(false);
                setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
            }
            else{
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Auto Assignment', alertMsg: 'Something went wrong!!!' , displayFooter: true});
                setRouteAlert(true);
                props.disbaleButton(false);
                setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));

            }
        }
    }

    // Function to update records
    const updateSelectedRecords = (DTSelectedRecordsForARB, myData) => {
        let isUpdated = false; // Track if any data is added

        DTSelectedRecordsForARB?.forEach(record => {
            const confirmationNo = record.Confirmation;

            // Check if confirmationNo already exists in normalizedSelectedData
            const exists = myData?.normalizedSelectedData.some(data => data?.iRefId === confirmationNo);

            if (!exists) {
                // Add to normalizedSelectedData
                myData?.normalizedSelectedData.push({
                    ServiceID: record.ServiceID,
                    ScheduleID: record.ScheduleID,
                    iRefId: confirmationNo
                });

                // Add to SelectedRecordsForARB
                myData?.SelectedRecordsForARB.push({
                    AffiliateID: record.AffiliateID,
                    ServiceID: record.ServiceID,
                    ScheduleID: String(record.bIsSchedule).toUpperCase() === "TRUE" ? record.ScheduleID : "-1",
                    Confirmation: confirmationNo,
                    PickupDateTime: record.PickupDateTime,
                    ManifestNumber: record.ManifestNumber,
                    SchDetailID: record.SchDetailID,
                    Group: record.Group
                });

                isUpdated = true; // Mark as updated
            }
        });

        // If data was updated, store it in sessionStorage
        if (isUpdated) {
            let mynewData = {
                vServiceIDs: myData?.vServiceIDs,
                vScheduleIDs: myData?.vScheduleIDs,
                normalizedSelectedData: myData?.normalizedSelectedData,
                pickupDateTime: myData?.pickupDateTime,
                affID: myData?.affID,
                manifestNumber: myData?.manifestNumber,
                callBackURL: myData?.callBackURL,
                SelectedRecordsForARB: myData?.SelectedRecordsForARB,
                SelectedRouteSettingID: myData?.SelectedRouteSettingID
            };

            sessionStorage.setItem('RecordIDs', JSON.stringify(mynewData));
        }
    };



    async function getAllRoutes(routeSelected) {
        let route = routeSelected.substring(8);
        const selectedGridData = props.GridRowData;
        const affID = selectedGridData[0].iSRATSPID;
        const pickupDateTime = selectedGridData[0].PickupDateTime;
        let filteredData = AffiliateData.filter(item => String(item.AffiliateID) === affID);
        let iTransTypeValue = '0';
        if (filteredData.length > 0 && filteredData[0].iTransType !== undefined && filteredData[0].iTransType !== null) {
            iTransTypeValue = String(filteredData[0].iTransType);
        }
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllTodaysRoutes?selected_date=" + pickupDateTime + "&affiliate_id=" + affID + "&iTransType=" + iTransTypeValue, "get", { "Content-Type": "application/json" }, null, null);
        if (response.data) {
            clusterComboData.current = response.data;
            let data = clusterComboData.current.find((item) => item.vVirtualRoute === route);
            let date = data.dtRouteStartTime.split("T")[0];
            let selectedRoutes = "";
            let unSelectedRoutes = "";
            let selectedDepots = "";
            let selectedVeh = "";
            for (let k = 0; k < clusterComboData.current.length; k++) {
                if (Object.values(clusterComboData.current[k])[0] && clusterComboData.current[k].SelectedForTheDay) {
                    selectedDepots += String(clusterComboData.current[k].iDepot) + ",";
                    selectedVeh += String(clusterComboData.current[k].iVehicleID) + ",";
                    selectedRoutes += String(clusterComboData.current[k].vVirtualRoute) + ",";
                }
                else if (clusterComboData.current[k].vVirtualRoute != route) {
                    unSelectedRoutes += "'" + String(clusterComboData.current[k].vVirtualRoute) + "',";
                }
            }
            selectedRoutes += data.vVirtualRoute + ",";
            selectedDepots += data.iDepot + ",";
            selectedVeh += data.iVehicleID + ",";
            let params = {
                "vSettingName": data.vSettingName,
                "dtSelectedDate": date,
                "iSettingID": parseInt(data.iSettingID),
                "selectedRoutes": selectedRoutes,
                "selectedVehicle": selectedVeh,
                "selectedDepots": selectedDepots,
                "unSelectedRoutes": unSelectedRoutes,
                "currentlySelectedRoute": route,
                "isDay": true
            }
            let response1 = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/SaveSelectedDaysForDate", "post", { "Content-Type": "application/json" }, params, null);
            let result = response1.data;
        }
    }

    function GetServiceNScheduleIDsForWillMRM_New(array, bwillCallReqs) {
        var bwillCallReqsLocal = false;
        try {
            bwillCallReqsLocal = bwillCallReqs;
        } catch (Error) { }
        var result = Array();
        var service_ids = "";
        var schedule_ids = "";
        var trips = [];
        //var smaIDs = "";
        for (var i = 0; i < array.length; i++) {
            if (/*array[i].Route == "" && */(array[i].PickupTime != "Will Call")) {
                if ((array[i].bIsSchedule == "1")) {
                    schedule_ids += array[i].iScheduleID + ",";
                    trips.push({
                        "iScheduleID": array[i].iScheduleID,
                        "dtPickupDateTime": array[i]["PickupDateTime"],
                        "iRefID": array[i]["ConfirmationNo"]
                    });
                }
                else {
                    service_ids += array[i].ServiceID + ",";
                    trips.push({
                        "iServiceID": array[i].ServiceID,
                        "dtPickupDateTime": array[i]["PickupDateTime"],
                        "iRefID": array[i]["ConfirmationNo"]
                    });
                }
            }
        }
        try {
            if ((service_ids != "") && (service_ids[service_ids.length - 1] == ','))
                service_ids = service_ids.substring(0, (service_ids.length - 1));

            if ((schedule_ids != "") && (schedule_ids[schedule_ids.length - 1] == ','))
                schedule_ids = schedule_ids.substring(0, (schedule_ids.length - 1));
        } catch (Error) { }
        result.push(service_ids);
        result.push(schedule_ids);
        result.push(trips);
        return result;
    }

    const NewRoute = async (serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj, myData) => {
        props.disbaleButton(true);
        let Param = {
            "assigned_driver_id": 0,
            "assigned_vehicle_id": 0,
            "service_ids_str": serIDs,
            "schedule_ids_str": schIDs,
            "mini_cluster_type": type,
            "req_date_str": reqDate,
            "manifest_number": manifest,
            "affiliate_id": affID,
            "requested_page_name": "ClusteringActions",
            "mandatory_grouping": mandatoryGrouping,
            "user_id": loginData.iUserID,
            "app_id": 26,
            "selected_records_for_cb": JSON.stringify(arrObj),
            "call_back_url": cbURL,
            "SelectedRouteSettingID": String(props.SelectedRouteSettingID)
        }
        setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing In Progress', alertMsg: 'Please Wait...', displayFooter: false });
        setRouteAlert(true);
        props.disbaleButton(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/MakeRoute", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if (result.run_id > 0) {
            updateSelectedRecords(result.DTSelectedRecordsForARB, myData);
            setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Started', alertMsg: 'Routing is being performed...', displayFooter: false });
            setRouteAlert(true);
            props.disbaleButton(false);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Route', alertMsg: result.error_message, displayFooter: true });
            setRouteAlert(true);
            props.disbaleButton(false);
        }
        else {
            setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Route', alertMsg: 'Something went wrong !!!', displayFooter: true });
            setRouteAlert(true);
            props.disbaleButton(false);
        }

    }

    const handleRouteAlertClose = () => {
        setRouteAlert(false);
        UnMountRouteComponent();
    }

    const UnMountRouteComponent = () => {
        if (props.showRouteActionCreate) {
            props.setRouteActionCreate(false);
        }
    }

    const handleConfirmationModalOk = () => {
        CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        RoutingActions();
    }

    const handleConfirmationModalSimpleOk = () => {
        setConfirmationModalSimpleObj((prevState) => ({ ...prevState, show: false }));
    }


    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setRouteActionCreate(false)
    }
    const handleConfirmationModalSimpleCancel = () => {
        setConfirmationModalSimpleObj((prevState) => ({ ...prevState, show: false }));
    }

    const handleConfirmationModalForDayOk = () => {
        setConfirmationModalObjForDay((prevState) => ({ ...prevState, show: false }));
        setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Initializing Routing Process', alertMsg: 'Please Wait...', displayFooter: false });
        setRouteAlert(true);
        var storedDataJSON = sessionStorage.getItem('RecordIDs');
        var storedData = JSON.parse(storedDataJSON);
        let with_ersa = "1";
        if (props.force_assign) with_ersa = "0";
        getAllRoutes(storedData.manifestNumber);
        NewRoute(storedData.vServiceIDs, storedData.vScheduleIDs, storedData.pickupDateTime, storedData.affID, with_ersa, storedData.manifestNumber, false, storedData.callBackURL, storedData.SelectedRecordsForARB);
    }

    const handleConfirmationModalForDayCancel = () => {
        setConfirmationModalObjForDay((prevState) => ({ ...prevState, show: false }));
        setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Initializing Routing Process', alertMsg: 'Please Wait...', displayFooter: false });
        setRouteAlert(true);
        var storedDataJSON = sessionStorage.getItem('RecordIDs');
        var storedData = JSON.parse(storedDataJSON);
        let with_ersa = "1";
        if (props.force_assign) with_ersa = "0";
        NewRoute(storedData.vServiceIDs, storedData.vScheduleIDs, storedData.pickupDateTime, storedData.affID, with_ersa, storedData.manifestNumber, false, storedData.callBackURL, storedData.SelectedRecordsForARB);


    }

    const handleConfirmationModalForDayClose = () => {
        setConfirmationModalObjForDay((prevState) => ({ ...prevState, show: false }));
        props.disbaleButton(false);
        props.setRouteActionCreate(false)
    }

    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setRouteActionCreate(false)
    }

    const handleConfirmationModalSimpleClose = () => {
        setConfirmationModalSimpleObj((prevState) => ({ ...prevState, show: false }));
    }

    return (
        <>
            {showRouteAlert && <Modal centered keyboard={false} show={showRouteAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                <Modal.Header>
                    <Modal.Title>{routeAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{routeAlertObj.alertMsg}</b></Modal.Body>
                {routeAlertObj.displayFooter ?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRouteAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                    : ""}
            </Modal>}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
                btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />
                
            <ConfirmationModal show={confirmationModalSimpleObj.show} Title={confirmationModalSimpleObj.title} Body={confirmationModalSimpleObj.body}
            onOk={handleConfirmationModalSimpleOk} onCancel={handleConfirmationModalSimpleCancel} onClose={handleConfirmationModalSimpleClose} btnCanceText={confirmationModalSimpleObj.btnCanceText}
            btnOkText={confirmationModalSimpleObj.btnOkText} ShowCancelButton="false" />

            <ConfirmationModal show={confirmationModalObjForDay.show} Title={confirmationModalObjForDay.title} Body={confirmationModalObjForDay.body}
                onOk={handleConfirmationModalForDayOk} onCancel={handleConfirmationModalForDayCancel} onClose={handleConfirmationModalForDayClose} btnCanceText={confirmationModalObjForDay.btnCanceText}
                btnOkText={confirmationModalObjForDay.btnOkText} ShowCancelButton="true" />
        </>
    );

};

export default Route;